import axios from 'axios';
import { API_BASE_URL } from '../config';

// Helper to get admin token
const getAdminToken = () => localStorage.getItem('adminKey') || '';

// Create axios instance with admin auth header
const adminApi = axios.create({
  baseURL: API_BASE_URL,
});

// Add admin token to all requests
adminApi.interceptors.request.use((config) => {
  config.headers['x-admin-token'] = getAdminToken();
  return config;
});

export { adminApi, getAdminToken };
export default adminApi;
